import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Avisos globales para permisos (403) y licencia vencida (402).
api.interceptors.response.use(
  (r) => r,
  (e) => {
    const status = e?.response?.status;
    const url = e?.config?.url || "";
    const method = (e?.config?.method || "").toLowerCase();
    if (!e.response && !navigator.onLine && method !== "get") {
      toast.error("Sin conexión: no se guardaron los cambios. Reintenta cuando vuelva la señal.");
    } else if (status === 403 && !url.includes("/auth/")) {
      toast.error(e?.response?.data?.detail || "No tienes permiso para esta acción");
    } else if (status === 402) {
      toast.error("La licencia de tu empresa está vencida o inactiva");
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
